export default "__VITE_ASSET__BBPKw4q___"